var sidebarStuff = angular.module('SidebarStuff', []);

sidebarStuff.service('OptionSidebar', [function () {
    /**
     * array with configurations-tab-configurations for some of the build-in slots...
     * @type {[msSidebarConfig]}
     */
    var configurations = [
        {
            key: 'header',
            title: 'Header',
            visible: function (context_type) {
                return context_type == 'site';
            }
        },

        {
            key: 'footer',
            title: 'Footer',
            visible: function (context_type) {
                return context_type == 'site';
            }
        },

        {
            key: 'section',
            title: 'Abschnitt',
            visible: function (context_type) {
                return context_type == 'section';
            }
        },

        {
            key: 'alignment',
            title: 'Ausrichtung',
            visible: function (context_type) {
                return context_type == 'slot';
            }
        },

        {
            key: 'font',
            title: 'Schrift',
            visible: function (context_type, context) {
                // show font for image-slot only if a caption exists.
                if (context_type != 'slot' || context.type != 'image' || (context.settings && context.settings.caption)) {
                    return ['site', 'section', 'slot'].indexOf(context_type) >= 0;
                }
                return false;
            }
        },

        {
            key: 'site-background',
            title: 'Hintergrund',
            visible: function (context_type) {
                return context_type == 'site';
            }
        },

        {
            key: 'section-background',
            title: 'Hintergrund',
            visible: function (context_type) {
                return context_type == 'section';
            }
        },

        {
            key: 'slot-background',
            title: 'Hintergrund',
            visible: function (context_type) {
                return context_type == 'slot';
            }
        },

        {
            key: 'address',
            title: 'Impressum',
            visible: function (context_type, context) {
                return context_type == 'site' || (context_type == 'slot' && context.type == 'address');
            }
        },

        {
            key: 'image-caption',
            title: 'Bildunterschrift',
            visible: function (context_type, context) {
                return context_type == 'slot' && context.type == 'image';
            }
        },

        {
            key: 'padding',
            title: 'Abstände',
            visible: function (context_type, context) {
                return context_type == 'section';
            }
        }
    ];

    /**
     * check config.enable_explicit

     * @param {msSidebarConfig} config
     * @param {msSite} site
     * @private
     */
    function _isEnabled(config, site) {
        return !!(config.enable_explicit && site.settings && site.settings.msExt && site.settings.msExt[config.key]);
    }

    // TODO: key: _custom

    var sidenav = {
        /**
         * current used context (msSite|msSection|msGroup|msSlot...);
         */
        current_context: null,

        current_site: null,
        current_section: null,
        current_group: null,
        current_slot: null,

        /**
         * current context type as string (site/section/group/slot)
         */
        current_context_type: null,

        /**
         * the currently visible configurations-tabs in the sidebar.
         * will be updated with switchContext()
         */
        visible_configurations: [],

        /**
         * the currently selected & visible configuration
         */
        selected_configuration: null,

        /**
         * @param config {msSidebarConfig}
         */
        selectConfiguration: function (config) {
            sidenav.selected_configuration = config;
        },

        /**
         * @param new_context {msSite|msSection|msGroup|msSlot}
         * @param context_type {String} - the type as string. site/section/group/slot
         * @param site {msSite} - the root element
         * @param section {msSection}
         * @param group {msGroup}
         * @param slot {msSlot}
         */
        switchContext: function (new_context, context_type, site, section, group, slot) {
            if (new_context === sidenav.current_context) {
                return;
            }
            sidenav.current_context = new_context;
            sidenav.current_context_type = context_type;
            sidenav.visible_configurations = [];
            sidenav.current_site = site;
            sidenav.current_section = section;
            sidenav.current_group = group;
            sidenav.current_slot = slot;

            configurations.forEach(function (config) {
                if ((!config.enable_explicit || _isEnabled(config, site))) {
                    sidenav.visible_configurations.push(config);
                }
            });
        },

        /**
         * add another sidebar configuration tab... (extensions register their configurations with this method)
         * @param entry {msSidebarConfig}
         */
        registerEntry: function (entry) {
            configurations.push(entry);
        },

        /**
         * remove a configuration
         * should never be used. !?
         * @param key {String}
         */
        unregisterEntry: function (key) {
            for (var i = 0; i < configurations.length; i++) {
                if (configurations[i].key == key) {
                    configurations.splice(i, 1);
                    return;
                }
            }
        }
    };
    return sidenav;
}]);
